import { inMarketTheme } from '@inmarket/inmarkit';
import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ScheduleSelectorRaw from 'react-schedule-selector';

import { backgroundColor } from '../../constants/style';

// Use Jan 1, 2017 because it lands on a Sunday
export const START_DATE = new Date('2017/01/01');

type ScheduleSelectorProps = {
  name: string;
  normalizeOutput?: Function;
  normalizeInput?: Function;
};

function ScheduleSelector(props: ScheduleSelectorProps) {
  const { name, normalizeOutput = (event) => event, normalizeInput = (input) => input } = props;

  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const handleChange = (newSchedule) => {
    field.onChange(newSchedule.map((output) => normalizeOutput(output)));
  };

  const selection = useMemo(
    () => field.value && field.value.map((input) => normalizeInput(input, START_DATE)),
    [field.value, normalizeInput]
  );

  return (
    <Typography>
      <ScheduleSelectorRaw
        key={selection?.join(',')}
        selection={selection}
        numDays={7}
        minTime={0}
        maxTime={24}
        hourlyChunks={1}
        dateFormat="ddd"
        startDate={START_DATE}
        onChange={handleChange}
        selectedColor={inMarketTheme.palette.primary.main}
        hoveredColor="#488527"
        unselectedColor={backgroundColor}
      />
    </Typography>
  );
}

export default ScheduleSelector;
